import React from 'react';
import './Recommendations.css';
import chrisProfilePic from '../images/ansa.png'; // Adjust the path based on your directory structure

const Recommendations: React.FC = () => {
  return (
    <div className='timeline-container'>
      <div className="recommendation-card">
        <div className="recommendation-header">
          <img src={chrisProfilePic} alt="Chris Smith" className="profile-pic" />
          <div>
            <h3>Shyam Deo Singh</h3>
            <p>CEO of Ansabyte Technologies</p>
            <p className="date">June 23, 2024</p>
          </div>
        </div>
        <div className="recommendation-body">
          <p>✨ I highly recommend Gourav for his outstanding performance during his internship at AnsaByte. Gourav demonstrated a remarkable ability to learn quickly and a strong determination to excel. His go-getter attitude and sharp acumen were evident throughout his tenure.</p>
          <p>💡 He consistently delivered fabulous results and approached every task with enthusiasm and diligence. Whether it was tackling challenging problems or adapting to new tools and workflows, Gourav showed an impressive level of professionalism and focus.</p>
          <p>🌟 Gourav would be a valuable asset to any team, and I am confident in his ability to contribute effectively in his future endeavors.</p>
        </div>
      </div>
    </div>
  );
};

export default Recommendations;
